export default __webpack_public_path__ + "static/media/megane-colour-3.530d744d.jpg";